// extracted by mini-css-extract-plugin
module.exports = {"bttn":"CustomerGrid_bttn__mXq00","indebted":"CustomerGrid_indebted__1EhzH","creditor":"CustomerGrid_creditor__2pMsC","CustomerGridItem":"CustomerGrid_CustomerGridItem__UDrCx"};